import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  weeklyTimesheetsList: [],
  weeklyTimesheetRecord: null,
  redirectToList: false,
  validation_error: "",
  showUpdateForm: false,
  showViewPage: false,
  formState: {}
};

const WeeklyTimesheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.WEEKLY_TIMESHEET_REQUEST:
      return { ...state, loading: true, redirectToList: false, validation_error: "" };
    case types.WEEKLY_TIMESHEET_SUCCESS:
      return { ...state, loading: false, weeklyTimesheetsList: action.weeklyTimesheetsList };
    case types.WEEKLY_TIMESHEET_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        weeklyTimesheetRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.CLEAR_WEEKLY_TIMESHEETS:
      return { ...state, weeklyTimesheetsList: [], weeklyTimesheetRecord: null };
    case types.WEEKLY_TIMESHEET_VALIDATION_ERROR: 
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.WEEKLY_TIMESHEET_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        weeklyTimesheetRecord: null,
        formState: {},
        validation_error: ""
      };
    case types.HIDE_WEEKLY_TIMESHEET_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
          const new_validation_error = { ...state.validation_error };
          delete new_validation_error[action.feild_key];
          return { ...state, validation_error: new_validation_error };
      }
      return state;
    default:
      return state;
  }
};

export default WeeklyTimesheetReducer;
